// Environment Configuration for Frontend
// This file handles environment variables for different environments

// Debug environment variables
// console.log('=== ENVIRONMENT DEBUG ===');
// console.log('REACT_APP_API_URL:', process.env.REACT_APP_API_URL);
// console.log('REACT_APP_FRONTEND_URL:', process.env.REACT_APP_FRONTEND_URL);
// console.log('NODE_ENV:', process.env.NODE_ENV);

const config = {
  // API Configuration
  API_URL: process.env.REACT_APP_API_URL || 'http://192.168.1.13:8000',
  API_TIMEOUT: parseInt(process.env.REACT_APP_API_TIMEOUT) || 30000,
  
  // Frontend Configuration
  FRONTEND_URL: process.env.REACT_APP_FRONTEND_URL || 'http://localhost:3000',
  
  // Environment
  ENV: process.env.REACT_APP_ENV || 'development',
  DEBUG: process.env.REACT_APP_DEBUG === 'true' || false,
  
  // App Configuration
  APP_NAME: process.env.REACT_APP_APP_NAME || 'Restaurant App',
  APP_VERSION: process.env.REACT_APP_APP_VERSION || '1.0.0',
  
  // Feature Flags
  ENABLE_ANALYTICS: process.env.REACT_APP_ENABLE_ANALYTICS === 'true' || false,
  ENABLE_LOGGING: process.env.REACT_APP_ENABLE_LOGGING === 'true' || true,
  
  // External Services
  GOOGLE_MAPS_API_KEY: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '',
  STRIPE_PUBLIC_KEY: process.env.REACT_APP_STRIPE_PUBLIC_KEY || '',
  
  // Development Settings
  ENABLE_HOT_RELOAD: process.env.REACT_APP_ENABLE_HOT_RELOAD === 'true' || true,
  ENABLE_DEBUG_TOOLS: process.env.REACT_APP_ENABLE_DEBUG_TOOLS === 'true' || true,
  
  // Helper methods
  isDevelopment: () => config.ENV === 'development',
  isProduction: () => config.ENV === 'production',
  isTesting: () => config.ENV === 'testing',
  
  // API helpers
  getApiUrl: (endpoint = '') => `${config.API_URL}${endpoint}`,
  
  // Frontend helpers
  getFrontendUrl: (path = '') => `${config.FRONTEND_URL}${path}`,
  getPublicUrl: (path = '') => `${config.FRONTEND_URL}${path}`,
  
  // Logging
  log: (message, ...args) => {
    if (config.DEBUG) {
      // console.log(`[${config.APP_NAME}]`, message, ...args);
    }
  },
  
  error: (message, ...args) => {
    if (config.ENABLE_LOGGING) {
      console.error(`[${config.APP_NAME}]`, message, ...args);
    }
  }
};

export default config;
